import { observer } from 'mobx-react';
import Link from 'next/link';
import { action } from 'mobx';
import * as React from 'react';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

export interface Props {
  title: React.ReactNode;
  icon: string;
  href: string;
}

@observer
export class PortalAsideCategoryItem extends React.Component<Props, {}> {
  static contextType = StoreContext;
  declare context: Store;

  get isCategoryItemActive() {
    const { requestStore } = this.context;
    const { pathurl } = requestStore.requestLocation;
    const { href } = this.props;
    if (pathurl === href) {
      return true;
    }
    return false;
  }

  render() {
    const { portalStore } = this.context;

    const { title, icon, children, href } = this.props;

    return (
      <li className={`menu-item ${this.isCategoryItemActive ? ' menu-item-active' : ''}`} aria-haspopup="true">
        <Link href={href}>
          <a className="menu-link" onClick={action(() => (portalStore.isAsidePanelOpen = false))}>
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">{title}</span>
          </a>
        </Link>
      </li>
    );
  }
}
